import { useMutation } from '@tanstack/react-query';

import {
  type Notes_UpsertNotesTagInput,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { peopleKeys } from '../keys';

const upsertNoteTags = graphql(/* GraphQL */ `
  mutation notes_upsertNotesTags($input: [Notes_UpsertNotesTagInput]) {
    notes_upsertNotesTags(input: $input) {
      id
    }
  }
`);

export function useUpsertNoteTags() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: Notes_UpsertNotesTagInput[]) =>
      gqlClient.request(upsertNoteTags, { input }),
    onSuccess: async (_, [note]) => {
      await queryClient.invalidateQueries({
        queryKey: peopleKeys.notes.noteTags(),
      });

      toast.success(
        note
          ? t('common:snackbarMessages.updateSuccess')
          : t('common:snackbarMessages.createSuccess'),
      );
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
